module.exports = "static/assets/89833a109ba5105c76ee1fb007d6811b.svg";